<template>
  <section class="py-16 md:py-20 px-6 md:px-12 lg:px-24 bg-white" id="services">
    <h2 class="text-5xl md:text-6xl lg:text-5xl font-black text-[#39ab58] text-center mb-12">
      {{ $t('services.title') }}
    </h2>

    <div class="timeline-container grid grid-cols-1 md:grid-cols-2 gap-12">
      <!-- Timeline line and content -->
      <div class="timeline-left" :class="{ 'order-2 md:order-1': $i18n.locale === 'ar' }">
        <ol class="relative border-s border-[#346BB3]" style="height: 89%;">
          <li v-for="(service, index) in services" :key="index" class="mb-10 ms-4">
            <div class="absolute w-3 h-3 bg-[#346BB3] rounded-full mt-2 -start-1.5 border border-white"
              :class="$i18n.locale === 'ar' ? '-start-1.5' : '-start-1.5'"></div>

            <div class="space-y-2">
              <div class="inline-flex items-center gap-2">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-[#346BB3]">
                  {{ $t(service.title) }}
                </h3>
                <lord-icon :src="service.icon" trigger="loop" colors="primary:#121331,secondary:#1663c7"
                  class="w-8 h-8">
                </lord-icon>
              </div>

              <p class="text-base font-normal text-gray-500 dark:text-gray-400">
                {{ $t(service.description) }}
              </p>
            </div>
          </li>
        </ol>
      </div>

      <!-- Images -->
      <div class="timeline-right grid grid-cols-2 gap-6" :class="{ 'order-1 md:order-2': $i18n.locale === 'ar' }">
        <div class="timeline-image">
          <img src="../assets/img/1.webp" :alt="$t('services.images.tracking')"
            class="w-full h-[120px] object-contain transition-all duration-300 hover:scale-105" />
        </div>
        <div class="timeline-image">
          <img src="../assets/img/2.png" :alt="$t('services.images.fleet')"
            class="w-full h-[120px] object-contain transition-all duration-300 hover:scale-105" />
        </div>

        <div class="timeline-image col-span-2">
          <img src="../assets/img/3.webp" :alt="$t('services.images.geofencing')"
            class="w-full h-[120px] object-contain transition-all duration-300 hover:scale-105" />
        </div>

        <div class="timeline-image">
          <img src="../assets/img/4.png" :alt="$t('services.images.driver')"
            class="w-full h-[120px] object-contain transition-all duration-300 hover:scale-105" />
        </div>
        <div class="timeline-image">
          <img src="../assets/img/5.webp" :alt="$t('services.images.emergency')"
            class="w-full h-[120px] object-contain transition-all duration-300 hover:scale-105" />
        </div>
      </div>
    </div>
  </section>

  <div class="hidden md:block self-stretch divider-gradient"></div>
</template>

<script>
export default {
  name: 'OurServices',
  data() {
    return {
      services: [
        {
          title: 'services.items.tracking.title',
          description: 'services.items.tracking.description',
          icon: 'https://cdn.lordicon.com/onmwuuox.json'
        },
        {
          title: 'services.items.fleet.title',
          description: 'services.items.fleet.description',
          icon: 'https://cdn.lordicon.com/grcrdebf.json'
        },
        {
          title: 'services.items.geofencing.title',
          description: 'services.items.geofencing.description',
          icon: 'https://cdn.lordicon.com/rpviwvwn.json'
        },
        {
          title: 'services.items.driver.title',
          description: 'services.items.driver.description',
          icon: 'https://cdn.lordicon.com/refarhxm.json'
        },
        {
          title: 'services.items.emergency.title',
          description: 'services.items.emergency.description',
          icon: 'https://cdn.lordicon.com/lltgvngb.json'
        },
        {
          title: 'services.items.data.title',
          description: 'services.items.data.description',
          icon: 'https://cdn.lordicon.com/fikcyfpp.json'
        },
        {
          title: 'services.items.app.title',
          description: 'services.items.app.description',
          icon: 'https://cdn.lordicon.com/sobzmbzh.json'
        }
      ]
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap');

[dir="ltr"] h2,
[dir="ltr"] h3,
[dir="ltr"] p {
  font-family: "Poppins", sans-serif;
}

[dir="rtl"] h2,
[dir="rtl"] h3,
[dir="rtl"] p {
  font-family: "Cairo", sans-serif;
}

.timeline-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.timeline-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.timeline-right {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.timeline-image img {
  width: 100%;
  height: 220px;
  object-fit: contain;
}

.divider-gradient {
  height: 22px;
  background: linear-gradient(90deg,
      rgba(162, 205, 222, 0) 0%,
      rgba(162, 205, 222, 1) 20%,
      rgba(215, 234, 236, 1) 49%,
      rgba(195, 230, 205, 1) 75%,
      rgba(195, 230, 205, 0) 100%,
      rgba(214, 234, 238, 1) 753%);
  width: 70%;
  margin: 0 auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  filter: blur(3px);
}

[dir="rtl"] .divider-gradient {
  transform: scaleX(-1);
}

@media (max-width: 768px) {
  .timeline-container {
    grid-template-columns: 1fr;
  }

  .timeline-right {
    grid-template-columns: 1fr;
  }

  .divider-gradient {
    display: block;
  }
}
</style>
